import React from 'react';
import styles from './QRCode.module.css';

const QRCode = ({ song, onReveal }) => {
  const handleClick = (e) => {
    // Only allow reveal clicks when not revealed and not during a drag operation
    // The revealed state is now managed by SongCard, so we check song.revealed
    if (!song.revealed && onReveal) {
      e.stopPropagation(); // Prevent event from bubbling to parent drag handlers
      e.preventDefault();
      onReveal();
    }
  };

  // Show QR code (either generated or placeholder)
  if (song.qr_code_url) {
    return (
      <div className={styles.qr_code}>
        <div className={styles.qr_display}>
          <img
            src={song.qr_code_url}
            alt={`QR code for ${song.title} by ${song.artist}`}
            className={styles.qr_image}
          />
          <div className={styles.qr_label}>
            {song.spotify_track_id ? '📱 Scan to play on Spotify' : '📱 Scan to search on Spotify'}
          </div>
          {!song.revealed && (
            <div className={styles.qr_click_overlay} onClick={handleClick}>
              <div className={styles.reveal_prompt}>👆 Click to reveal song info</div>
            </div>
          )}
        </div>
      </div>
    );
  }

  // Show QR placeholder when QR not ready
  return (
    <div className={styles.qr_code}>
      <div
        className={`${styles.qr_placeholder} ${!song.revealed ? styles.clickable : ''}`}
        onClick={!song.revealed ? handleClick : undefined}
      >
        {!song.revealed ? '📱 Click for QR CODE' : '📱 QR CODE'}
      </div>
    </div>
  );
};

export default QRCode;